export enum defaultStringsEnum {
    unknown = 'unknown',
    tbd = 'TBD',
    na = 'N/A',
    empty = '',
}
